import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import './index.scss';
import ClientCloDealPermissioning from '$/pages/admin/client/client-detail/ClientCloDealPermissioning/ClientCloDealPermissioning';

const ClientCloDealPermissioningRoot: React.FC = () => {
  return <ClientCloDealPermissioning />;
};

const mapStateToProps = (_: AppState) => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ClientCloDealPermissioningRoot);
